import {
  createWarningMessage,
} from '@dapi/sdk/helpers';

export const orderNotEligibleForRefundWarning = createWarningMessage({
  code: '39446',
  title: 'ORDER NOT ELIGIBLE FOR REFUND',
  detail: 'Please check nonEligibilityReason for more details'
});

export const orderEligibleForManualRefund = createWarningMessage({
  code: '39545',
  title: 'ORDER ELIGIBLE FOR MANUAL REFUND',
  detail: 'Your order may be refundable, but it will require manual processing. Please call order cancellation endpoint so the Order can be queued and refund is handled by an agent.'
});

export const servicesNotRefundableWarning = createWarningMessage({
  code: '39449',
  title: 'YOUR SERVICES WILL NOT BE REFUNDED',
  detail: 'Services are not refundable'
});

export const servicesCancelledWarning = createWarningMessage({
  code: '39469',
  title: 'SERVICES NOT REFUNDED',
  detail: 'Services have been cancelled'
});

export const noActiveItineraryWarning = createWarningMessage({
  code: '64938',
  title: 'NO ACTIVE ITINERARY IN ORDER',
  detail: 'No active itinerary in order'
});

export const lostServiceWarning = createWarningMessage({
  type: 'warning',
  code: '39610',
  title: 'LOST SERVICES'
});

export const flightDisruptionWarning = createWarningMessage({
  type: 'warning',
  code: '65227',
  title: 'FLIGHT DISRUPTION HAS OCCURRED: CHECK THE ORDER CONTENT'
});
